import React, { useState } from 'react';
import {
  Menu,
  Dropdown,
  Icon,
  Button,
  Modal,
  Upload,
  message,
  Spin,
  Table,
  Select,
  Input,
  Row,
  Col,
} from 'antd';
import moment from 'moment';
import request from '../../../../utils//request';
import { API_ADMIN } from '../../../../utils/urls';
import { generalParamsWithPToStr } from '../../../../utils/math';

import './index.less';

const IMPORT_STATUS_MAP = {
  PROCESSING: '处理中',
  COMPLETED: '已完成',
  FAILED: '失败',
};

const getImportStatusText = (status) => IMPORT_STATUS_MAP[status] || status || '--';

const IMPORT_TYPE_OPTIONS = [
  { value: 'HISTORY_ORDER', label: '历史订单导入(含明细)' },
  { value: 'NEGATIVE_HISTORY_ORDER', label: '负数订单导入' },
  { value: 'STUFF_SUPPLIER_BILL', label: '代卖货主账导入' },
  { value: 'PERSONAL_SUPPLIER_BILL', label: '自营货主账导入' },
];

const uploadTypes = [
  {
    label: '货品导入',
    value: 1,
    fileTypeEnum: 'PRODUCT',
    templateUrl:
      'https://files.caixm.cn/prod/template/910/%E8%B4%A7%E5%93%81%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
    action: 'dataImport/basicData',
  },
  {
    label: '买家分类导入',
    value: 11,
    fileTypeEnum: 'CUSTOM_CATEGORY',
    templateUrl:
      'https://files.caixm.cn/prod/template/910/%E4%B9%B0%E5%AE%B6%E5%88%86%E7%B1%BB%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
    action: 'dataImport/basicData',
  },
  {
    label: '买家导入',
    value: 2,
    fileTypeEnum: 'CUSTOM',
    templateUrl:
      'https://files.caixm.cn/prod/template/910/%E4%B9%B0%E5%AE%B6%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
    action: 'dataImport/basicData',
  },
  {
    label: '货主导入',
    value: 3,
    fileTypeEnum: 'SUPPLIER',
    templateUrl:
      'https://files.caixm.cn/prod/template/%E8%B4%A7%E4%B8%BB%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
    action: 'dataImport/basicData',
  },

  {
    label: '历史赊欠导入(有货品)',
    value: 4,
    fileTypeEnum: '',
    successMessage: '导入中，请在导入历史查看最终导入结果',
    templateUrl:
      'https://files.caixm.cn/prod/template/891/%E8%AE%A2%E5%8D%95%E7%99%BD%E6%9D%A1%E6%A8%A1%E6%9D%BF.xlsx',
    action: 'dataImport/historyOrder',
  },
  {
    label: '历史赊欠导入(负数订单)',
    value: 7,
    fileTypeEnum: '',
    successMessage: '导入中，请在导入历史查看最终导入结果',
    templateUrl:
      'https://files.caixm.cn/prod/template/891/%E8%B4%9F%E6%95%B0%E8%AE%A2%E5%8D%95%E5%AF%BC%E5%85%A5.xlsx',
    action: 'dataImport/negativeHistoryOrder',
  },
  {
    label: '历史赊欠导入(无货品)',
    value: 5,
    fileTypeEnum: '',
    templateUrl: 'https://files.caixm.cn/prod/template/白条模板.xlsx',
    action: 'dataImport/simpleHistoryOrder',
  },
  {
    label: '代卖货主账导入',
    value: 8,
    fileTypeEnum: '',
    successMessage: '导入中，请在导入历史查看最终导入结果',
    templateUrl:
      'https://files.caixm.cn/prod/template/891/%E4%BB%A3%E5%8D%96%E8%B4%A7%E4%B8%BB%E8%B4%A6%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx',
    action: 'dataImport/stuffSupplierBill',
  },
  {
    label: '自营货主账导入',
    value: 9,
    fileTypeEnum: '',
    successMessage: '导入中，请在导入历史查看最终导入结果',
    templateUrl:
      'https://files.caixm.cn/prod/template/891/%E8%87%AA%E8%90%A5%E8%B4%A7%E4%B8%BB%E8%B4%A6%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx',
    action: 'dataImport/personalSupplierBill',
  },
  {
    label: '费用类型导入',
    value: 10,
    fileTypeEnum: 'FINANCE_TYPE',
    templateUrl:
      'https://files.caixm.cn/prod/template/891/%E8%B4%B9%E7%94%A8%E7%B1%BB%E5%9E%8B%E6%A8%A1%E7%89%88.xlsx',
    action: 'dataImport/basicData',
  },
];

const ButtonUploadFile = ({ stallId, businessCode }) => {
  const [visible, setVisible] = useState(false);
  const [errorMessageList, setErrorMessageList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorVisible, setErrorVisible] = useState(false);
  const [store, setStore] = useState({});
  const [historyVisible, setHistoryVisible] = useState(false);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyList, setHistoryList] = useState([]);
  const [historyErrorVisible, setHistoryErrorVisible] = useState(false);
  const [historyErrorList, setHistoryErrorList] = useState([]);
  const getDefaultHistoryQuery = () => ({
    typeName: undefined,
    businessCode: businessCode || '',
  });

  const [historyQuery, setHistoryQuery] = useState(getDefaultHistoryQuery);

  const fetchImportTaskList = (query = historyQuery) => {
    const params = {};
    if (query.typeName) {
      params.typeName = query.typeName;
    }
    if (query.businessCode?.trim()) {
      params.businessCode = query.businessCode.trim();
    }
    setHistoryLoading(true);
    request({
      url: 'dataImport/getImportTaskList',
      method: 'get',
      headers: 'json',
      params,
    })
      .then((res) => {
        const { code, data } = res;
        if (code === 200) {
          setHistoryList(Array.isArray(data) ? data : []);
        }
      })
      .finally(() => {
        setHistoryLoading(false);
      });
  };

  const handleOpenImportHistory = () => {
    const initialQuery = getDefaultHistoryQuery();
    setHistoryQuery(initialQuery);
    setHistoryVisible(true);
    fetchImportTaskList(initialQuery);
  };

  const handleHistorySearch = () => {
    fetchImportTaskList(historyQuery);
  };

  const handleHistoryReset = () => {
    const initialQuery = getDefaultHistoryQuery();
    setHistoryQuery(initialQuery);
    fetchImportTaskList(initialQuery);
  };

  const handleViewHistoryError = (record) => {
    setHistoryErrorList(record.errorMessageList || []);
    setHistoryErrorVisible(true);
  };

  const historyColumns = [
    {
      title: '导入类型',
      dataIndex: 'typeDesc',
      key: 'typeDesc',
      width: 180,
      ellipsis: true,
    },
    {
      title: '商行业务ID',
      dataIndex: 'businessCode',
      key: 'businessCode',
      width: 120,
    },
    {
      title: '导入时间',
      dataIndex: 'startTime',
      key: 'startTime',
      width: 186,
      render: (text) => (text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : '--'),
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      width: 90,
      render: (text) => getImportStatusText(text),
    },
    {
      title: '错误信息',
      dataIndex: 'errorMessageList',
      key: 'errorMessageList',
      render: (list, record) => {
        if (!list?.length) {
          return '--';
        }
        return <a onClick={() => handleViewHistoryError(record)}>查看</a>;
      },
    },
  ];

  const importMenu = (
    <Menu>
      {uploadTypes.map((item) => (
        <Menu.Item
          key={String(item.value)}
          onClick={() => {
            setStore(item);
            setVisible(true);
          }}
        >
          {item.label}
        </Menu.Item>
      ))}
    </Menu>
  );

  const beforeUpload = (file) => {
    setLoading(true);
    const checkSize = file.size / 1024 / 1024 < 20;
    if (!checkSize) {
      message.error('单个文件不能超过20M!');
      setLoading(false);
    }
    return checkSize;
  };

  const uploadContractProps = {
    className: 'uploader',
    accept: '.xls,.xlsx',
    name: 'file',
    listType: 'picture-card',
    action: `${API_ADMIN}${store.action}?${generalParamsWithPToStr(`${store.action}`, {})}`,
    headers: {},
    beforeUpload: beforeUpload,
    showUploadList: false,
    maxCount: 1,
    customRequest: (options) => {
      const params = { file: options.file, stallId, fileTypeEnum: store.fileTypeEnum };
      setLoading(true);
      request({ url: options.action, params, headers: 'form-data', method: 'post' }).then((res) => {
        setLoading(false);
        const { code, data = {} } = res;
        if (code === 200) {
          if (data?.errorMessageList?.length > 0) {
            setVisible(false);
            setErrorMessageList(data?.errorMessageList || []);
            setErrorVisible(true);
          } else {
            Modal.success({
              content: store.successMessage || '导入成功',
            });
            setVisible(false);
          }
        } else {
          message.error(res.msg);
        }
      });
    },
  };

  const { templateUrl, label } = uploadTypes.find((types) => types.value === store.value) || {};

  return (
    <>
      <Dropdown overlay={importMenu} trigger={['click']}>
        <Button type='primary' style={{ background: '#01b755', width: 116, marginRight: 16 }}>
          导入 <Icon type='down' />
        </Button>
      </Dropdown>
      <Button
        type='primary'
        style={{ background: '#01b755', width: 116, marginRight: 16 }}
        onClick={handleOpenImportHistory}
      >
        导入历史
      </Button>
      <Modal
        title={label || '导入'}
        visible={visible}
        onOk={() => setVisible(false)}
        onCancel={() => setVisible(false)}
        destroyOnClose
        maskClosable={false}
      >
        <Spin spinning={loading}>
          <Upload {...uploadContractProps}>
            <Icon type='upload' />
            <p>点击此处选择文件</p>
          </Upload>
          <div>
            <p>1、仅支持Excel，单个文件不超过20M</p>
            <p>2、确保表格内只有一个工作簿，如果有多个工作簿只有第一个会被处理</p>
            <p>
              3、<a href={templateUrl}>{label}模板下载</a>
            </p>
          </div>
        </Spin>
      </Modal>
      <Modal
        title='导入结果提示'
        visible={errorVisible}
        onOk={() => setErrorVisible(false)}
        onCancel={() => setErrorVisible(false)}
        destroyOnClose
        footer={[
          <Button type='primary' onClick={() => setErrorVisible(false)}>
            我知道了
          </Button>,
        ]}
      >
        <h3>导入失败，错误信息如下：</h3>
        <div style={{ maxHeight: 360, overflowY: 'scroll' }}>
          {errorMessageList.map((item, index) => {
            return <p key={index}>{item}</p>;
          })}
        </div>
      </Modal>
      <Modal
        title='导入历史'
        visible={historyVisible}
        onCancel={() => setHistoryVisible(false)}
        destroyOnClose
        width={800}
        footer={[
          <Button key='close' onClick={() => setHistoryVisible(false)}>
            关闭
          </Button>,
        ]}
      >
        <Row gutter={16} style={{ marginBottom: 16 }}>
          <Col span={8}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ flexShrink: 0, marginRight: 8 }}>导入类型：</span>
              <Select
                allowClear
                placeholder='请选择导入类型'
                style={{ flex: 1 }}
                value={historyQuery.typeName}
                onChange={(value) => setHistoryQuery({ ...historyQuery, typeName: value })}
              >
                {IMPORT_TYPE_OPTIONS.map((item) => (
                  <Select.Option key={item.value} value={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
          <Col span={8}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ flexShrink: 0, marginRight: 8 }}>商行业务ID：</span>
              <Input
                allowClear
                placeholder='请输入商行业务ID'
                style={{ flex: 1 }}
                value={historyQuery.businessCode}
                onChange={(e) => setHistoryQuery({ ...historyQuery, businessCode: e.target.value })}
                onPressEnter={handleHistorySearch}
              />
            </div>
          </Col>
          <Col span={8}>
            <Button type='primary' style={{ marginRight: 8 }} onClick={handleHistorySearch}>
              查询
            </Button>
            <Button onClick={handleHistoryReset}>重置</Button>
          </Col>
        </Row>
        <Table
          rowKey={(record, index) => record.taskId || index}
          loading={historyLoading}
          columns={historyColumns}
          dataSource={historyList}
          pagination={false}
          scroll={{ y: 400 }}
        />
      </Modal>
      <Modal
        title='导入错误信息'
        visible={historyErrorVisible}
        onCancel={() => setHistoryErrorVisible(false)}
        destroyOnClose
        footer={[
          <Button type='primary' onClick={() => setHistoryErrorVisible(false)}>
            我知道了
          </Button>,
        ]}
      >
        <div style={{ maxHeight: 360, overflowY: 'scroll' }}>
          {historyErrorList.map((item, index) => {
            return <p key={index}>{item}</p>;
          })}
        </div>
      </Modal>
    </>
  );
};

export default ButtonUploadFile;
